import styled from "styled-components";
import Menu from "@material-ui/core/Menu";

export default styled(Menu)({});
